<template>
  <section class="page-common-form" v-cloak>
    <div class="vn-grid-small">
      <div v-if="userInfo.id" class="page-common-form__box">
        <h1 class="page-common-form__h">{{ userInfo.userName }}님의 데일리 학습 기록</h1>
        <form v-if="!completed" @submit.prevent="submitForm">
          <div class="vn-form-group">
            <label for="page-common-form-class" class="label">수강한 온라인 강의명</label>
            <input type="text" id="page-common-form-class" class="input" v-model="formData.courseTitle" required />
            <p class="hint">수강 기록을 제출하실 강의명을 입력해주세요.</p>
          </div>

          <div class="vn-form-group">
            <label for="page-common-form-clip" class="label">강의 클립 이름</label>
            <input type="text" id="page-common-form-clip" class="input" v-model="formData.clipTitle" required />
            <p class="hint">수강 기록을 제출하실 강의 클립 이름을 입력해주세요.</p>
          </div>

          <div class="vn-form-group">
            <label for="page-common-form-contents" class="label">학습 내용 정리</label>
            <textarea
              id="page-common-form-contents"
              class="textarea"
              v-model.trim="formData.contents"
              rows="100"
              required
            ></textarea>
            <p class="hint">배운 내용을 간략하게 정리합니다. 공백 미포함 100자 이상의 내용을 작성해야 합니다.</p>
            <span class="length-check">{{ formData.contents.length }}자 / {{ maxLength }}자</span>
          </div>

          <p v-if="error" class="error">에러! 잠시 후 다시 시도해주세요.</p>

          <div class="btn-group">
            <button type="submit" class="btn btn--lg btn--wide btn--curve" :disabled="invalided">제출하기</button>
          </div>
        </form>

        <div v-else class="page-common-form__message">
          <mission-icon />

          <p class="message">{{ userInfo.userName }}님의 {{ formData.courseTitle }} 학습 기록을 제출하였습니다.</p>

          <div class="btn-group">
            <button type="button" class="btn btn--dimmed btn--lg btn--wide btn--curve" @click="resetForm()">
              다시 작성하기
            </button>
            <a href="/" class="btn btn--lg btn--wide btn--curve">홈으로 이동</a>
          </div>
        </div>
      </div>

      <div v-else class="page-common-form__box">
        <div class="page-common-form__message">
          <h1 class="page-common-form__h">데일리 학습 기록</h1>

          <mission-icon />

          <div class="btn-group">
            <a href="/auth/login" class="btn btn--lg btn--wide btn--curve">로그인하러 가기</a>
          </div>

          <p class="message">
            패스트캠퍼스 온라인 60만원 환급 도전! 수강 기록을 작성하여 일일 미션을 수행을 완료하시려면, 패스트캠퍼스
            계정에 로그인을 해주세요! 일일 미션을 달성할 경우 월 5만 원이 환급 됩니다. (5만 원X6개월 = 총 30만 원)
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import api from './api';

import MissionIcon from './components/icons/mission-icon.vue';

const MAXLENGTH = 3;

export default {
  name: 'mission-form-app',
  components: {
    MissionIcon,
  },
  created() {
    const main = document.getElementById('main');

    this.pageId = main.dataset.pageId || undefined;
    this.getMyName();
  },
  computed: {
    invalided() {
      return !(this.formData.contents.length > this.maxLength);
    },
  },
  methods: {
    getUserName(data) {
      this.userInfo.id = data.userId;
      this.userInfo.userName = data.userName;
    },
    resetForm() {
      this.formData = {
        courseTitle: '',
        clipTitle: '',
        contents: '',
      };
      this.completed = false;
    },
    catchError() {
      this.error = true;

      setTimeout(() => {
        this.error = false;
      }, 3000);
    },
    async getMyName() {
      try {
        const response = await api.getMyInfo();
        response && response.data && response.data.data && this.getUserName(response.data.data);
      } catch (e) {
        new Error(e);
      }
    },
    async submitForm() {
      try {
        const response =
          !this.invalided &&
          (await api.postForm(this.pageId, {
            ...this.userInfo,
            ...this.formData,
          }));

        this.completed = response && response.data && response.data.data === 'OK';
      } catch (e) {
        this.catchError();
      }
    },
  },
  data() {
    return {
      maxLength: MAXLENGTH,
      pageId: undefined,
      userInfo: {
        id: undefined,
        userName: '',
      },
      formData: {
        courseTitle: '',
        clipTitle: '',
        contents: '',
      },
      invalidForm: true,
      completed: false,
      error: false,
    };
  },
};
</script>
